module.exports = __webpack_public_path__ + "img/icon-2.1955bfe5.png";